<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('brands')">Brands</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
    </div>
    <trashed-message v-if="brandData.deleted_at" class="mb-6" @restore="restore">
      This brand has been deleted.
    </trashed-message>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="full name" />
            <text-input v-model="form.percents" v-if="$can('repair-price')" :optional="true" placeholder="valeur separé par virgule ex: 10,15,20" :error="errors.percents" class="pr-6 pb-8 w-full lg:w-1/2" label="Pourcentage(s)" />
            <text-input v-model="form.amounts" v-if="$can('repair-price')" :optional="true" placeholder="valeur separé par virgule ex: 100,200" :error="errors.amounts" class="pr-6 pb-8 w-full lg:w-1/2" label="Montant(s)" />
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
          <button v-if="!brandData.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Brand</button>
          <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">Update Brand</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  props: {
    errors: Object,
    brandData: Object,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        name: this.brandData.name,
        amounts: this.brandData.amounts,
        percents: this.brandData.percents,
        id: this.brandData.id,
      },
    }
  },
  methods: {
    submit() {
      var data = new FormData()
      data.append('name', this.form.name || '')
      data.append('percents', this.form.percents || '')
      data.append('amounts', this.form.amounts || '')
      data.append('_method', 'put')

      this.$inertia.post(this.route('brands.update', this.brandData.id), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {

          }
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Brand?')) {
        this.$inertia.delete(this.route('brands.destroy', this.brandData.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Brand?')) {
        this.$inertia.put(this.route('brands.restore', this.brandData.id))
      }
    },
  },
}
</script>
